import React, {useEffect, useRef} from 'react';

import styles from './styles/detail-box.module.css';

import Dropdown from './Dropdown';
import {ReactComponent as CircleCheckbox} from '../../assets/chat/circle-checkbox.svg';

export default function DetailBox({ title, content, isStreaming, isOpenDropdown, toggleDropdown }) {
    const contentEndRef = useRef(null);
    
    useEffect(() => {
        if (contentEndRef.current && isStreaming) {
            // boxContent 내에서 스크롤
            const container = contentEndRef.current.closest(`.${styles.boxContent}`); // 1. contentEndRef의 부모 중 'boxContent' 클래스를 가진 가장 가까운 요소 찾기
            if (container) {
                container.scrollTop = container.scrollHeight;
            }
        }
    }, [content, isStreaming]);

    const renderContent = () => {
        if (!content) return null;
        
        const trimmedContent = content.startsWith('\n') ? content.substring(1) : content; // content 맨 앞의 줄바꿈(\n) 제거

        const chunkedContentList = trimmedContent.split(/(```)/g);

        const elementList = [];

        let isInCodeBlock = false; // 코드 블록 내부인지 여부

        chunkedContentList.forEach((chunk, index) => {
            if (chunk === '```') {
                isInCodeBlock = !isInCodeBlock;
            } else if (chunk) {    // ```가 아닌 경우
                if (isInCodeBlock) {
                    elementList.push(
                        <pre key={index} className={styles.codeBlock}>
                            <code>{chunk}</code>
                        </pre>
                    );
                } else {
                    elementList.push(<span key={index}>{chunk}</span>);
                }
            }
        });
        
        return elementList;
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.boxTitle}>
                <div className={styles.title}>
                    <CircleCheckbox />
                    {title}
                </div>
                <Dropdown
                    isOpenDropdown={isOpenDropdown}
                    toggleDropdown={toggleDropdown}
                />
            </div>
            {isOpenDropdown && content &&
                <div className={styles.boxContent}>
                    {renderContent()}
                    <div ref={contentEndRef} />
                </div>
            }
        </div>
    );
}
